import React from 'react';
import { LiveTranscriptBar } from './LiveTranscriptBar';
import { NewInquiryBar } from './NewInquiryBar';
import { useFeatures } from '../hooks/useFeatures';

// Renders the fixed sub-header row beneath the TopBar.
// Each half owns its own `relative` context so each bar's expanded dropdown
// stays within its half-width column rather than overlapping the other side.
export const CombinedInfoBar: React.FC = () => {
  // New Inquiries are live-AI detections, so the bar is only shown when live
  // intelligence is on. In post-call-only mode (Lushin default) the live
  // transcript takes the full width.
  const { liveIntelligence } = useFeatures();

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="flex min-w-0 divide-x divide-gray-200">
        <div className="flex-1 min-w-0 relative">
          <LiveTranscriptBar />
        </div>
        {liveIntelligence && (
          <div className="flex-1 min-w-0 relative">
            <NewInquiryBar />
          </div>
        )}
      </div>
    </div>
  );
};
